import React, { useLayoutEffect } from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';

import PersonIcon from '@material-ui/icons/Person';

import AccountSetupSection from '../../Components/AccountSetup/AccountSetupSection';
import SurveyFixedFooterActions from '../../../SurveyFixedFooterActions';
import { useSurveyStepContext } from '../../SurveyStepContext';
import { useSurveyContext } from '../../../SurveyContext';

const styles = () => ({
  root: {},
  footer: {},
  enableButton: {},
});

const AccountSetupSuccessLayout = ({
  classes,
}) => {
  const {
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const {
    onClickNext,
  } = useSurveyStepContext();

  // Restore navigator / header visibility upon unmount
  const { setNavbarVisibility, setHeaderVisibility } = useSurveyContext();
  useLayoutEffect(() => {
    return () => {
      setNavbarVisibility(true);
      setHeaderVisibility(true);
    };
  }, []);

  return (
    <div className={classes.root}>
      {/* ---------- Section title / icon / message ---------- */}
      <AccountSetupSection
        icon={PersonIcon}
        title={'Account Created!'}
        messages={[
          'You\'ve successfully created your account! You\'ll have the opportunity to update these settings later.',
        ]}
      />

      {/* ---------- Footer (Continue) ---------- */}
      <SurveyFixedFooterActions>
        <RoundedButton
          className={classes.enableButton}
          onClick={() => onClickNext(onSubmitMetaForm)}
          color={'primary'}
          variant={'contained'}
          disableElevation
          fullWidth
          test={'account-created-continue-button'}
        >
          {'Continue'}
        </RoundedButton>
      </SurveyFixedFooterActions>
    </div>
  );
};

AccountSetupSuccessLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

AccountSetupSuccessLayout.defaultProps = {
};

export default withStyles(styles)(AccountSetupSuccessLayout);
